import { createIcon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const CircuitWireThree: (props: IconProps) => JSX.Element = createIcon({
  displayName: `CircuitWireThree`,
  viewBox: `0 0 224 302`,
  path: (
    <g clipPath="url(#clip0_714_18565)" fill="none">
      <path
        opacity="0.2"
        d="M223.779 0H134.162C130.567 0 127.12 1.42785 124.578 3.96953C122.036 6.51122 120.609 9.95856 120.609 13.553V178.882C120.603 185.507 117.968 191.859 113.28 196.541L7.32852 302.493C2.64545 307.177 0.0100707 313.527 2.68397e-05 320.151V483.935"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path
        opacity="0.25"
        d="M147.891 5.47473H152.306V9.88939H147.891V5.47473Z"
        fill="currentColor"
      />
      <path
        d="M145.684 8.8293V8.25537H146.258V8.8293H145.684Z"
        fill="currentColor"
      />
      <path
        d="M145.728 7.1523V6.57837H146.301V7.1523H145.728Z"
        fill="currentColor"
      />
      <path
        d="M137.428 8.82991V8.25598H138.002V8.82991H137.428Z"
        fill="currentColor"
      />
      <path
        d="M137.428 7.196V6.62207H138.002V7.196H137.428Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M151.246 9.35957V8.78564H151.82V9.35957H151.246Z"
        fill="currentColor"
      />
      <path
        opacity="0.25"
        d="M148.995 8.82935V6.0481H151.776V8.82935H148.995Z"
        fill="currentColor"
      />
      <path
        opacity="0.25"
        d="M148.465 9.40333V6.62207H151.246V9.40333H148.465Z"
        fill="currentColor"
      />
      <path
        opacity="0.25"
        d="M139.636 5.47473H144.05V9.88939H139.636V5.47473Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M142.946 9.40327V8.82935H143.52V9.40327H142.946Z"
        fill="currentColor"
      />
      <path
        opacity="0.25"
        d="M140.739 8.82984V6.04858H143.521V8.82984H140.739Z"
        fill="currentColor"
      />
      <path
        opacity="0.25"
        d="M140.209 9.35963V6.57837H142.99V9.35963H140.209Z"
        fill="currentColor"
      />
      <path
        opacity="0.25"
        d="M131.336 5.47473H135.751V9.88939H131.336V5.47473Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M134.69 9.35957V8.78564H135.264V9.35957H134.69Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M140.166 6.62202V6.0481H140.74V6.62202H140.166Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M131.91 6.62251V6.04858H132.484V6.62251H131.91Z"
        fill="currentColor"
      />
      <path
        opacity="0.25"
        d="M132.44 8.82935V6.0481H135.222V8.82935H132.44Z"
        fill="currentColor"
      />
      <path
        opacity="0.25"
        d="M131.91 9.40333V6.62207H134.691V9.40333H131.91Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M129.129 7.15173H129.703V7.72564H129.129V7.15173Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M128.025 7.15173H128.599V7.72564H128.025V7.15173Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M128.025 6.0481H128.599V6.622H128.025V6.0481Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M129.129 6.0481H129.703V6.622H129.129V6.0481Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M128.025 8.78564H128.599V9.35955H128.025V8.78564Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M129.129 8.78564H129.703V9.35955H129.129V8.78564Z"
        fill="currentColor"
      />
    </g>
  ),
  defaultProps: {
    width: `100%`,
    height: `100%`,
    fill: `none`,
  },
});

export default CircuitWireThree;
